import { axios as request } from "../../request/http";

const interfaceUrl = {
    "api_spGroupQuery": "/base/spGroup/query", // 查询资金商分组
    "api_spGroupQueryList": "/base/spGroup/queryList", // 查询资金商分组
}

// initial state
const state = {
    spGroupList: {},
}

// getters
const getters = {
    getSpGroupList: state => {
        return state.spGroupList
    },
}

// actions
const actions = {
    getSpGroup: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_spGroupQuery,
            method: "GET",
            params,
        };
        return request(option).then(res => res.data).then(res => {
            if (res.code == 200) {
                // commit('SP_GROUP_LIST', res.data || []);
            } else {
                // commit('SP_GROUP_LIST', []);
            }
        }).catch(err => {
            // commit('SP_GROUP_LIST', []);
        })
    },
    getSpGroupList: ({
        commit,
        state
    }, params) => {
        params = params || {};
        let option = {
            url: interfaceUrl.api_spGroupQueryList,
            method: "POST",
            data: params,
        };
        return request(option).then(res => res.data).then(res => {
            if (res.code == 200) {
                commit('SP_GROUP_LIST', res || {});
            } else {
                commit('SP_GROUP_LIST', {});
            }
        }).catch(err => {
            commit('SP_GROUP_LIST', {});
        })
    },
}


// mutations
const mutations = {
    SP_GROUP_LIST: (state, pageData) => {
        state.spGroupList = pageData;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/spGroup.js